module.exports = __webpack_public_path__ + "img/1guUQGTCCyTTDDVurX1ZQSiHP-sCvdaJU.a548b732.png";